module.exports = __webpack_public_path__ + "static/mango-3b4cc101586507a1918e6b3fe048f604.svg";